import Marquee from "react-fast-marquee";
import { Image as ImageType } from "shared/types";
import Image from "shared/images";

export const Talk = () => {
  const data: ImageType[] = [
    "talkPrimaComunicazione",
    "talkDagospia",
    "talkLaRepubblica",
    "talkAg",
    "talkIlGiornale",
    "talkAvvenire",
    "talkIlFoglio",
    "talkAdnkronos",
    "talkAnsa",
    "talkCorriereDellaSera",
    "talkIlMessaggero",
    "talkOpen",
    "talkOsservatoreRomano",
    "talkRai",
    "talkTheRomaPost",
  ];

  return (
    <>
      <div className="container full m-auto">
        <h3 className="heading h-3 mb-3"> Parlano di noi
        </h3>
      </div>
      <div className="talk">
        <Marquee>
          {data.map((item, index) => {
            return (
              <div key={index} className="talk__item">
                <Image name={item} title="" />
              </div>
            );
          })}
        </Marquee>
      </div>
    </>
  );
};
